import "../../App.css";
import { useEffect, useState } from "react";
import CartSidebar from "../../components/Cart/CartSidebar";

import MainSection from "../../secciones/MainSection/MainSection";
import Carrusel_Pillars from "../../components/carrusel_pillars/carrusel_pillars";
import TeamCarousel_merged from "../../components/card_hover_carrusel/carrusel_and_card_hover/carrusel_and_card_hover";
import MarcasCarousel from "../../components/carrusel_automatico_marcas/carrusel_automatico_marcas";
import ContactForm from "../../secciones/ContactForm/ContactForm";
import Introduccion from "../../secciones/Introduccion/Introduccion";
import Articles from "../Articles/Articles";


import svgAprendizajePilares from "../../assets/pillars/el_aprendizajeTitulo.svg";
import svgTituloMarcas from "../../assets/logos_marcas/lineaTitulo.svg";

import "../../components/Specialist.css";
import "../../components/Pillars.css";

function Home({ courses, user, setIsCartOpen}) {
  console.log("carro?setIsCartOpen:", setIsCartOpen)
  
  return (
    <>
      <MainSection />
      <Introduccion />


      {/* ================= PILARES ================= */}
      <section className="pillars-section section-white ">
        <div className="container">
          <div className="container-pillars">
            <div className="pillars-header">
              
              <div className="banner-svg-container-start"  style={{ margin: "0px 0px" }}>
                <div className="svg-wrapper" style={{ width: "80%" }}>
                  <img src={svgAprendizajePilares} alt="" />
                </div>
              </div>

              <div className="header-carrusel">
                <Carrusel_Pillars />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= ESPECIALISTAS ================= */}
      <section className="specialists-section section-green">
        <div className="container">
          <h2 className="title" style={{ color: "white" }}>
            COMUNIDAD DE ESPECIALISTAS
          </h2>
          <TeamCarousel_merged />
        </div>
      </section>

      {/* ================= MARCAS ================= */}
      <section
        className="pillars-section section-white"
      >
        <div className="container">
          <div className="header-left">
            <h2 className="title title_marcas" style={{ color: "#117475" }}>
              Empresas con las que hemos trabajado
            </h2>
            <div className="logo">
              <img src={svgTituloMarcas} alt="" style={{ width: "1350px" }} />
            </div>
          </div>

          <div style={{ marginTop: "30px" }}>
            <MarcasCarousel />
          </div>
        </div>
      </section>

            
      {/* ================= ARTICLES================= */}
      <Articles />
      {/* ================= CONTACT FORM ================= */}
      <ContactForm />


  
    </>
  );
}

export default Home;
